/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AutoResizingCanvas from '../../../AutoResizingCanvas';
import ComponentBase from '../../../ComponentBase';
import CLog, { LogTypes } from '../../../ComponentLogger';
import OrientationComponent from './OrientationComponent';
import OrientationScaler from './OrientationScaler';
import OrientationWidget from './OrientationWidget';
import OrientationComponentBase from './OrientationComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class OrientationHelper extends ComponentBase
{
    @property()
    public set SwitchOrientation(value: boolean)
    {
        const autoCanvas: AutoResizingCanvas = this.node.getComponent(AutoResizingCanvas);
        const canvas: cc.Canvas = this.node.getComponent(cc.Canvas);
        let isLandscape: boolean = false;

        if (canvas.designResolution.equals(autoCanvas.LandscapeSize))
        {
            CLog.log("Setting canvas to portrait.", LogTypes.Editor);
            canvas.designResolution = autoCanvas.PortraitSize;
        }
        else
        {
            CLog.log("Setting canvas to landscape.", LogTypes.Editor);
            canvas.designResolution = autoCanvas.LandscapeSize;
            isLandscape = true;
        }

        for (let comp of this.getComponentsInChildren(OrientationComponentBase))
        {
            comp.SwitchOrientation(isLandscape);
        }
    }
    public get SwitchOrientation(): boolean { return false; }
}
